<div class="flex justify-start content-center items-center flex-row">
  @if (showDownloadBtn()) {
    <button mat-icon-button="" class="list-button" matTooltip="Download document" (click)="downloadDocument.emit(document())">
      <mat-icon>get_app</mat-icon>
    </button>
  }
  @if (showEditBtn()) {
    <button mat-icon-button="" class="list-button" [matTooltip]="'Edit document' | translate" (click)="showEdit.emit(document())">
      <mat-icon>edit</mat-icon>
    </button>
  }
  <a class="has-list-button flex flex-row justify-start content-center items-center h-full" (click)="openDocument.emit(document())">
    <!-- (click)="showEdit.emit(document())" -->
    <div class="document-icon">
      @switch (fileExtension()) {
        @case ('.docx') {
          <mat-icon>insert_drive_file</mat-icon>
          <span class="lbl blue">{{fileExtension()}}</span>
        }
        @case ('.doc') {
          <mat-icon>insert_drive_file</mat-icon>
          <span class="lbl blue">{{fileExtension()}}</span>
        }
        @case ('.txt') {
          <mat-icon>insert_drive_file</mat-icon>
          <span class="lbl blue">{{fileExtension()}}</span>
        }
        @case ('.rtf') {
          <mat-icon>insert_drive_file</mat-icon>
          <span class="lbl blue">{{fileExtension()}}</span>
        }
        @case ('.pages') {
          <mat-icon>insert_drive_file</mat-icon>
          <span class="lbl blue">{{fileExtension()}}</span>
        }
        @case ('.pdf') {
          <mat-icon>insert_drive_file</mat-icon>
          <span class="lbl red">{{fileExtension()}}</span>
        }
        @case ('.jpeg') {
          <mat-icon>image</mat-icon>
          <span class="lbl purple">{{fileExtension()}}</span>
        }
        @case ('.jpg') {
          <mat-icon>image</mat-icon>
          <span class="lbl purple">{{fileExtension()}}</span>
        }
        @case ('.png') {
          <mat-icon>image</mat-icon>
          <span class="lbl purple">{{fileExtension()}}</span>
        }
        @case ('.gif') {
          <mat-icon>image</mat-icon>
          <span class="lbl purple">{{fileExtension()}}</span>
        }
        @case ('.xlsx') {
          <mat-icon>insert_drive_file</mat-icon>
          <span class="lbl green">{{fileExtension()}}</span>
        }
        @case ('.xls') {
          <mat-icon>insert_drive_file</mat-icon>
          <span class="lbl green">{{fileExtension()}}</span>
        }
        @case ('.numbers') {
          <mat-icon>insert_drive_file</mat-icon>
          <span class="lbl green">{{fileExtension()}}</span>
        }
        @case ('.csv') {
          <mat-icon>insert_drive_file</mat-icon>
          <span class="lbl green">{{fileExtension()}}</span>
        }
        @case ('.pptx') {
          <mat-icon>insert_drive_file</mat-icon>
          <span class="lbl orange">{{fileExtension()}}</span>
        }
        @case ('.ppt') {
          <mat-icon>insert_drive_file</mat-icon>
          <span class="lbl orange">{{fileExtension()}}</span>
        }
        @default {
          <mat-icon>insert_drive_file</mat-icon>
          <span class="lbl gray">{{fileExtension()}}</span>
        }
      }
    </div>
    <div class="ml2 flex flex-col justify-start content-start items-start h-full">
      <div mat-line="" class="title">
        @if (document().documentType) {
          <span class="small gray">{{document().documentType.id}}</span>
          }.
          {{document().description}}
        </div>
        <ul mat-line="" class="sub mt0 flex flex-row justify-start content-center items-center h-full">
          <li class="mr2">
            <mat-icon>calendar_today</mat-icon>
            {{document().created | date:'longDate'}}
          </li>
          @if (linkText() != null) {
            <li class="mr2">
              <mat-icon>link</mat-icon>
              <span>{{linkText()}}</span>
            </li>
          }
          @if (!linkText()) {
            <li class="mr2 warn">
              <mat-icon>link_off</mat-icon>
              <span translate="">Not linked</span>
            </li>
          }
          @if (document().documentType) {
            <li class="mr2">
              <mat-icon>attach_file</mat-icon>
              {{document().documentType.name}}
            </li>
          }
        </ul>
      </div>
    </a>
  </div>
